<template>
  <div class="card" id="movement">
    <nav class="fixed-bar navbar navbar-expand-lg navbar-light" color="white">
      <h3 class="navbar-brand">Movement</h3>
      <add-movement
        @save="saveSetDesign"
        @open="openDialog"
        @close="closeDialog"
        v-bind:dialog="dialog"
        v-bind:info="editedItem"
        v-bind:edited-i-d="editedID">
      </add-movement>
    </nav>
    <hr/>
    <div class="container fluid grid-list-lg">
      <asset-table
        v-bind:updated="updated"
        v-bind:asset_type="asset_type"
        @edit="editItem"
        v-bind:headers="headers"
        >

      </asset-table>
    </div>
  </div>
</template>

<script>
  import AddMovement from './add-new/addMovement'
  import {db, assetMediaStorageRef, assetModelStorageRef} from '../../firebaseDB'
  import AssetTable from './assetTable'

  export default {
    name: 'movement',
    components: {AssetTable, AddMovement},
    data: () => ({
      fileType: {
        image: 'image',
        file: 'file'
      },
      asset_type: 'movement',
      headers: [
        {th: 'Path Type', name: 'pathType'},
        {th: 'Date Uploaded', name: 'date_uploaded'},
        // {th: 'Date Modified', name: 'date_modified'},
        {th: 'Uploaded By', name: 'creator'},
        {th: 'Target', name: 'target'},
        {th: 'Position of Origin', name: 'positionOfOrigin'}
      ],
      dialog: '',
      updated: false,
      editedItem: {
        id: null,
        pathType: '',
        orientationType: '',
        duration: 0,
        waypoints: '',
        destinationProximity: '',
        positionOfOrigin: {
          X: 0,
          Y: 0,
          Z: 0
        },
        target: '',
        rotation: ''
      },
      defaultItem: {
        id: null,
        pathType: '',
        orientationType: '',
        duration: 0,
        waypoints: '',
        destinationProximity: '',
        positionOfOrigin: {
          X: 0,
          Y: 0,
          Z: 0
        },
        target: '',
        rotation: ''
      },
      editedID: -1,
      editedIndex: -1,
      tableData: []
    }),
    // created () {
    //   this.initialize()
    // },
    methods: {
      saveSetDesign (updatedData) {
        const currentdate = new Date()
        const datetime = currentdate.getDate() + '/' +
          (currentdate.getMonth() + 1) + '/' +
          currentdate.getFullYear() + ' @ ' +
          currentdate.getHours() + ':' +
          currentdate.getMinutes() + ':' +
          currentdate.getSeconds()
        setTimeout(() => {
          let updates = {}
          let requireDefaultUpdate = true
          if (!updatedData.id) {
            updatedData.id = db.ref(`asset_data/${this.asset_type}/`).push().key
            updates[`asset_data/${this.asset_type}/${updatedData.id}/meta_data/creator`] = this.$store.state.user.email
            updates[`asset_data/${this.asset_type}/${updatedData.id}/meta_data/date_uploaded`] = datetime
          }
          updates[`asset_data/${this.asset_type}/${updatedData.id}/pathType`] = updatedData.pathType || ''
          updates[`asset_data/${this.asset_type}/${updatedData.id}/orientationType`] = updatedData.orientationType || ''
          updates[`asset_data/${this.asset_type}/${updatedData.id}/duration`] = updatedData.duration || ''
          updates[`asset_data/${this.asset_type}/${updatedData.id}/waypoints`] = updatedData.waypoints || ''
          updates[`asset_data/${this.asset_type}/${updatedData.id}/destinationProximity`] = updatedData.destinationProximity || ''
          updates[`asset_data/${this.asset_type}/${updatedData.id}/positionOfOrigin`] = {
            X: updatedData.positionOfOrigin.X || '0',
            Y: updatedData.positionOfOrigin.Y || '0',
            Z: updatedData.positionOfOrigin.Z || '0'
          }
          updates[`asset_data/${this.asset_type}/${updatedData.id}/target`] = updatedData.target || ''
          updates[`asset_data/${this.asset_type}/${updatedData.id}/rotation`] = updatedData.rotation || ''
          updates[`asset_data/${this.asset_type}/${updatedData.id}/componentType`] = updatedData.componentType || 'Character'
          updates[`asset_data/${this.asset_type}/${updatedData.id}/meta_data/date_modified`] = datetime

          if (requireDefaultUpdate) {
            db.ref('assets').update(updates).then(snapshot => {
              this.closeDialog()
              this.updated = true
            })
          }
        }, 500)
        this.updated = false
      },
      shouldUpload (fileType, updatedData) {
        if (fileType === this.fileType.image) {
          return updatedData.image && updatedData.image.imageFile
        } else if (fileType === this.fileType.file) {
          return updatedData.Media && updatedData.Media.file
        }
      },
      uploadImage (updatedData, updates) {
        assetMediaStorageRef.child(`${updatedData.id}.jpg`)
          .put(updatedData.image.imageFile)
          .then(snapshot => snapshot.ref.getDownloadURL())
          .catch(function (error) {
            console.log(`Error - ${error.message}`)
          })
          .then((url) => {
            updatedData.image.imageURL = url
          })
          .catch(function (error) {
            console.log(`Error - ${error.message}`)
          })
          .then(snapshot => {
            updates[`asset_data/${this.asset_type}/${updatedData.id}/image`] = updatedData.image || {imageURL: '', imageFile: ''}
            console.log('Your image file is saved in storage')
            db.ref('assets').update(updates)
              .then(snapshot => {
                this.closeDialog()
                this.updated = true
                console.log('Your image fileURL is saved in assets')
              })
          })
          .catch(function (error) {
            console.log('Error - ' + error.message)
          })
      },
      uploadFile (updatedData, updates) {
        if (updatedData.Media && updatedData.Media.file) {
          assetModelStorageRef.child(`${updatedData.id}/Media`)
            .put(updatedData.Media.file)
            .then(snapshot => snapshot.ref.getDownloadURL())
            .catch(function (error) {
              console.log(`Error - ${error.message}`)
            })
            .then((url) => {
              updatedData.Media.fileURL = url
              console.log('Transferring Media file url')
            })
            .then(snapshot => {
              let key = `asset_data/${this.asset_type}/${updatedData.id}/Media`
              updates[key] = updatedData.Media || {
                fileURL: '',
                file: ''
              }
              console.log(`Your Media file is saved in storage`)
              db.ref('assets').update(updates)
                .then(snapshot => {
                  this.closeDialog()
                  this.updated = true
                  console.log(`Your Media fileURL is saved in assets`)
                })
            })
        }
      },
      // uploadFBX (updatedData, updates) {
      //   assetModelStorageRef.child(`${updatedData.id}/original.fbx`)
      //     .put(updatedData.fbx.file)
      //     .then(snapshot => snapshot.ref.getDownloadURL())
      //     .catch(function (error) {
      //       console.log(`Error - ${error.message}`)
      //     })
      //     .then((url) => {
      //       updatedData.fbx.fileURL = url
      //       console.log('Transferring file url')
      //     })
      //     .then(snapshot => {
      //       updates[`asset_data/${this.asset_type}/${updatedData.id}/fbx`] = updatedData.fbx || {
      //         fileURL: '',
      //         file: ''
      //       }
      //       console.log('Your fbx file is saved in storage')
      //       db.ref('assets').update(updates)
      //         .then(snapshot => {
      //           this.closeDialog()
      //           this.updated = true
      //           console.log('Your fbx fileURL is saved in assets')
      //         })
      //     })
      // },
      openDialog () {
        this.dialog = true
      },
      closeDialog () {
        this.editedID = -1
        this.editedIndex = -1
        this.editedItem = Object.assign({}, this.defaultItem)
        this.dialog = false
      },
      editItem (item) {
        this.editedIndex = item.index
        this.editedID = item.id
        this.editedItem = item.item
        if (!this.editedItem.hasOwnProperty('positionOfOrigin')) {
          this.editedItem.positionOfOrigin = {
            X: 0,
            Y: 0,
            Z: 0
          }
        }
        if (!this.editedItem.hasOwnProperty('rotationOfOrigin')) {
          this.editedItem.rotationOfOrigin = {
            X: 0,
            Y: 0,
            Z: 0
          }
        }
        this.dialog = true
      }
    }
  }
</script>

<style scoped>
#twoDMedia{
  scroll-margin: 150px;
}
</style>



// WEBPACK FOOTER //
// src/components/assets/movement.vue